import {
	IBoxComponent,
	IFormConfigLabels,
	isBoxComponentInput,
	isBoxComponentWithOptions,
} from '@enuan/chat__utils';

export const getFormLabels = (
	fields?: IBoxComponent<object>[],
	values?: Record<string, any>
) =>
	fields?.reduce<IFormConfigLabels[]>((prev, curr) => {
		const { id } = curr;
		if (
			(isBoxComponentInput(curr) && curr.inputType === 'password') ||
			!id ||
			!Object.keys(values ?? {}).includes(id)
		) {
			return prev;
		}

		const field: IFormConfigLabels = {
			id: id,
			label: curr.label,
			value: isBoxComponentWithOptions(curr)
				? curr.options
						.filter((option) => (values?.[id] ?? []).includes(option.value))
						.map((options) => options.label)
				: undefined,
		};
		return [...prev, field];
	}, []) ?? [];
